
import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { ApiError } from '@empathyco/playboard-core-domain'
import type { IndexJobServiceListFilters } from '../services'
import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import { PermissionLevelEnum } from '@empathybroker/tsclient-play/dist/enums/permission-level.enum'
import { computed, defineComponent, getCurrentInstance, reactive, ref } from 'vue'
import IndexJobFilters from '../components/index/index-jobs-filters.component.vue'
import IndexJobsTable from '../components/index/index-jobs-table.component.vue'
import IndexSubmitJobForm from '../components/index/index-submit-job-form.component.vue'
import IndexUpdateJobConfigForm from '../components/index/index-update-job-config-form.component.vue'
import { UiTooltip } from '../components/keen-ui'
import { EpbButton } from '../components/shared/epb-button'
import { mapGetters } from '../composables'
import { FeatureIdEnum } from '../enums'
import { CONFIG_CONSTS } from '../store/config/config.consts'

export default defineComponent({
  name: 'Index',
  components: {
    EpbButton,
    IndexJobFilters,
    IndexJobsTable,
    IndexSubmitJobForm,
    IndexUpdateJobConfigForm,
    UiTooltip,
  },
  setup(_props, { emit }) {
    const {
      proxy: { $epb, $store },
    } = getCurrentInstance()

    const baseClass = 'epb-index'

    const messages = $epb.messages.tools.index

    const filters = reactive<IndexJobServiceListFilters>({
      clientIds: [],
      feedIds: [],
      states: [],
    })

    const indexJobsTableRef = ref()

    const { instances } = mapGetters<Array<Instance>>($store, CONFIG_CONSTS.moduleName, {
      instances: CONFIG_CONSTS.getters.instances,
    })

    const setFilters = (settledFilters: IndexJobServiceListFilters): void => {
      Object.assign(filters, { clientIds: [], feedIds: [], states: [] }, settledFilters)
    }

    const success = (text: string, resetTable = false): void => {
      emit('showSnackbar', text)
      if (resetTable) {
        indexJobsTableRef.value.resetTable()
      }
    }

    const error = (error: ApiError): void => {
      emit('showError', error)
    }

    const reload = (): void => {
      return indexJobsTableRef.value.fetchData()
    }

    const countDown = computed((): string => {
      return $epb.utils.compileMessage(messages.timeToReload, {
        time: indexJobsTableRef.value?.intervalTime || 0,
      })
    })

    const visibleInstances = computed((): Instance[] => {
      return instances.value.filter(instance =>
        instance.domains[DomainEnum.GLOBAL]?.permissions.some(
          permission =>
            permission.id === FeatureIdEnum.INSTANCE_MANAGEMENT &&
            permission.level !== PermissionLevelEnum.NONE,
        ),
      )
    })

    return {
      baseClass,
      filters,
      indexJobsTableRef,
      visibleInstances,
      success,
      error,
      setFilters,
      countDown,
      reload,
    }
  },
})
